export default __webpack_public_path__ + "static/media/greenroom-logo.0a5549d1.svg";